export default "__VITE_ASSET__Co3PWjpz__"